import { SVG } from '@svgdotjs/svg.js'

export default class svgFrame {
   constructor(element) {
      this.fps = 30;
      this.fpsInterval = 1000 / this.fps;
      this.startTime = '';
      this.now = '';
      this.then = Date.now();
      this.elapsed = '';
      
      this.textpaths = [];
      this.scale = 1.0;
      // this.resize = this.resize.bind(this);
      this.demolish = this.demolish.bind(this);
      
      this.border = window.innerWidth < 800 ? 60 : 140;
      this.fontsize = window.innerWidth < 800 ? 10 : 22;
      this.width = $(element).outerWidth()
      this.height = $(element).outerHeight()

      this.element = element;

      this.draw = SVG().addTo(element).size(this.width, this.height);


      this.addFrame();

      this.draw.addClass('svgFrame');

      // console.log('new frame for ',element);
      
      window.svgFrames.push(this);

   }

   addFrame() {

      console.log(this.height);

      var path2 = false;
      
      if($(this.element).is(':first-of-type')){
         var path = this.draw.path([
            ['M', this.border*.5, this.height-this.border*.125],
            ['Q', 0, this.height-this.border*.5, 0, this.height-this.border],
            ['V', this.border],
            ['Q', 0, 0, this.border, 0],
            ['H', this.width - this.border],
            ['Q', this.width, 0, this.width, this.border],
            ['V', this.height - this.border],
            ['Q', this.width, this.height, this.width - this.border, this.height],
            ['H', this.width*.5 - 10],
         ]);
      } else if($(this.element).is(':not(:last-of-type)')){
         var path = this.draw.path([
            ['M', this.width*.5 + 10, this.fontsize],
            ['L', this.border, this.fontsize],
            ['Q', this.fontsize, this.fontsize, this.fontsize, this.border],
            ['L', this.fontsize, this.height-this.border],
            ['Q', this.fontsize, this.height-this.fontsize, this.border, this.height-this.fontsize],
            ['L', this.width*.5 + 10, this.height-this.fontsize],
         ]);
         
         path2 = this.draw.path([
            ['M', this.width-this.border*.4, this.height-this.fontsize*1.5],
            ['Q', this.width-this.fontsize, this.height-this.border*.33, this.width-this.fontsize, this.height-this.border],
            ['V', this.fontsize+this.border],
            ['Q', this.width-this.fontsize, this.fontsize+this.border*.2, this.width-this.fontsize-this.border*.3, this.fontsize+this.border*.1],
            // ['z']
         ]);
      } else {
         var path = this.draw.path([
            ['M', this.width*.5 - 10, 0],
            ['L', this.width-this.border, 0],
            ['Q', this.width, 0, this.width, this.border],
            ['V', this.height-this.border],
            ['Q', this.width, this.height, this.width-this.border, this.height],
            ['H', this.border],
            ['Q', 0, this.height, 0, this.height-this.border],
            ['V', this.border],
            ['Q', 0, this.border*.25, this.border*.33, this.border*.1],
            // ['Q']
            // ['Q', pt2],
            // ['V', pt3],
            // ['Q', pt4],
            // ['H', pt5],
            // ['Q', pt6],
            // ['V', pt7],
            // ['Q', pt8],
            // ['H', pt9],
            // ['z']
         ]);
      }
      
      path.attr({
         class: 'the-path',
         stroke: 'transparent',
         fill: 'transparent'
      });
      
      var word = $(this.element).attr('data-title');
      var wordlength = word.split('').length;
      
      let times = 150;
      // let times = ((this.height+this.width)/wordlength * 0.3) * (22/this.fontsize);
      
      let words = '';
      for(let w=0; w < times; w++) {
         words += word+' ';
      }
      
      var tspan;
      var t = this;
      var text = this.draw.text(function(add) {
         tspan = add.tspan(words).dy(t.fontsize*.82);
      })
      
      if(!MOBILE) {
         var textpath = text.path(path).font({
            size: this.fontsize,
            family: 'SuisseIntl',
            weight: 'normal',
            // fill: 'red',
            fill: 'var(--color)',
            startOffset: '0%'
         });
      } else {
         var textpath = text.path(path).font({
            size: this.fontsize,
            family: 'SuisseIntl',
            weight: 'normal',
            // fill: 'red',
            fill: 'var(--color)',
            startOffset: '0%'
         }).animate({
            duration: 170 * 1000,
            delay: 0,
            when: 'now',
            easing: '=',
            swing: false,
            times: 999,
            wait: 0
         }).attr('startOffset', '-100%');
         textpath.timeline().pause();
      }

      if(path2) {
         var text2 = this.draw.text(function(add) {
            tspan = add.tspan(words).dy(t.fontsize*.82);
         })
         path2.attr({
            class: 'the-path',
            stroke: 'transparent',
            fill: 'transparent'
         });
         if(!MOBILE) {
            var textpath2 = text2.path(path2).font({
               size: this.fontsize,
               family: 'SuisseIntl',
               weight: 'normal',
               // fill: 'red',
               fill: 'var(--color)',
               startOffset: '0%'
            });
         } else {
            var textpath2 = text2.path(path2).font({
               size: this.fontsize,
               family: 'SuisseIntl',
               weight: 'normal',
               // fill: 'red',
               fill: 'var(--color)',
               startOffset: '0%'
            }).animate({
               duration: 170 * 1000,
               delay: 0,
               when: 'now',
               easing: '=',
               swing: false,
               times: 999,
               wait: 0
            }).attr('startOffset', '-100%');
            textpath2.timeline().pause();
         }
         textpath2.so = 0;
         textpath2.fontsize = this.fontsize;
         this.textpaths.push(textpath2);

         // window.textPaths.push(textpath2);

      }
      
      textpath.so = 0;
      textpath.fontsize = this.fontsize;
      this.textpaths.push(textpath);

   }

   demolish(){
      this.draw.remove();
   }
 }
 